import FidelityService from "../Services/FidelityService";

class FidelityProgramUtil {

    fidelityProgramService;

    constructor() {
        this.fidelityProgramService = new FidelityService();
    }

    static async get() {
        const meUtil = new FidelityProgramUtil();
        return await meUtil.get();
    }

    static async tryGetFidelity() {
        try {
            const fidelity = await FidelityProgramUtil.get();
            return fidelity.data.data[0];
        } catch (e) {
            return null;
        }
    }

    async get() {
        try {
            return this.fidelityProgramService.getByUser();
        } catch (e) {
            throw e;
        }
    }
}

export default FidelityProgramUtil;